
import { MapLocation } from '@/types/location';

// Waki Schools in Jeddah region
export const wakiSchoolsJeddah: MapLocation[] = [
  {
    id: 40001,
    name: "Alanjal (Rawdah)",
    type: "School",
    devices: 2,
    coordinates: [21.5753394, 39.0718579],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 487
    }
  },
  {
    id: 40002,
    name: "Rowad Alkhaleej (Obhur)",
    type: "School",
    devices: 4,
    coordinates: [21.7645505, 39.0885646],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 461
    }
  },
  {
    id: 40003,
    name: "Al Thuraya Model Schools (Murjan)",
    type: "School",
    devices: 2,
    coordinates: [21.68396, 39.10743],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male, Female",
    ageRange: "3-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Kindergarten, Elementary, Intermediate",
      students: 295
    }
  },
  {
    id: 40004,
    name: "Alandalus (Ashati) - Elementary Male",
    type: "School",
    devices: 1,
    coordinates: [21.6116371, 39.1140348],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 40005,
    name: "Alandalus (Ashati) - Intermediate Male",
    type: "School",
    devices: 1,
    coordinates: [21.6116371, 39.1140348],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate",
      students: 200
    }
  },
  {
    id: 40006,
    name: "Alandalus (Ashati) - Elementary Female",
    type: "School",
    devices: 1,
    coordinates: [21.6116371, 39.1140348],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 40007,
    name: "Alandalus (Ashati) - Intermediate Female",
    type: "School",
    devices: 1,
    coordinates: [21.6116371, 39.1140348],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate",
      students: 200
    }
  },
  {
    id: 40008,
    name: "Alandalus (Ashati) - Secondary Female",
    type: "School",
    devices: 2,
    coordinates: [21.6116371, 39.1140348],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "15-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Secondary",
      students: 200
    }
  },
  {
    id: 40009,
    name: "Alandalus Int'l (Ashati) - Elementary Female",
    type: "School",
    devices: 3,
    coordinates: [21.6121906, 39.1154914],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 40010,
    name: "Alandalus Int'l (Ashati) - Intermediate Female",
    type: "School",
    devices: 1,
    coordinates: [21.6121906, 39.1154914],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate",
      students: 200
    }
  },
  {
    id: 40011,
    name: "Alandalus Int'l (Ashati) - Elementary Male",
    type: "School",
    devices: 1,
    coordinates: [21.6121906, 39.1154914],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 40012,
    name: "Alandalus Int'l (Ashati) - Intermediate/Secondary Male",
    type: "School",
    devices: 1,
    coordinates: [21.6121906, 39.1154914],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40013,
    name: "Alandalus (Rawdah) - Elementary Male",
    type: "School",
    devices: 3,
    coordinates: [21.5669005, 39.1461597],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 40014,
    name: "Alandalus (Rawdah) - Intermediate Male",
    type: "School",
    devices: 2,
    coordinates: [21.5669005, 39.1461597],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate",
      students: 200
    }
  },
  {
    id: 40015,
    name: "Alandalus (Rawdah) - Secondary Male",
    type: "School",
    devices: 1,
    coordinates: [21.5669005, 39.1461597],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "15-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Secondary",
      students: 200
    }
  },
  {
    id: 40016,
    name: "Alandalus (Fayhaa) - Elementary Female",
    type: "School",
    devices: 1,
    coordinates: [21.5066384, 39.2030167],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 40017,
    name: "Alandalus (Fayhaa) - Intermediate Female",
    type: "School",
    devices: 1,
    coordinates: [21.5066384, 39.2030167],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate",
      students: 200
    }
  },
  {
    id: 40018,
    name: "Alandalus (Fayhaa) - Elementary/Intermediate Male",
    type: "School",
    devices: 1,
    coordinates: [21.5066384, 39.2030167],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate",
      students: 200
    }
  },
  {
    id: 40019,
    name: "Alandalus Int'l (Fayhaa) - Elementary Female",
    type: "School",
    devices: 1,
    coordinates: [21.5066384, 39.2030167],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 40020,
    name: "Alandalus Int'l (Fayhaa) - Intermediate Female",
    type: "School",
    devices: 1,
    coordinates: [21.5066384, 39.2030167],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate",
      students: 200
    }
  },
  {
    id: 40021,
    name: "Advanced Generations Schools (Nahdah) - Elementary Male",
    type: "School",
    devices: 2,
    coordinates: [21.6287162, 39.1232621],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 40022,
    name: "Advanced Generations Schools (Nahdah) - Intermediate/Secondary Male",
    type: "School",
    devices: 3,
    coordinates: [21.6287162, 39.1232621],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40023,
    name: "Advanced Generations Schools (Nahdah) - Elementary Female",
    type: "School",
    devices: 4,
    coordinates: [21.6287162, 39.1232621],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 40024,
    name: "Advanced Generations Schools (Nahdah) - Intermediate/Secondary Female",
    type: "School",
    devices: 2,
    coordinates: [21.6287162, 39.1232621],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40028,
    name: "Al Moktashef International School (MIS) - Shatee",
    type: "School",
    devices: 6,
    coordinates: [21.6098382, 39.0712501],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40029,
    name: "Al Moktashef International School (MIS) - Naeem",
    type: "School",
    devices: 2,
    coordinates: [21.6349667, 39.1310943],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40030,
    name: "Al Moktashef International School (MIS) - Downtown",
    type: "School",
    devices: 2,
    coordinates: [21.5550761, 39.1158886],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40031,
    name: "Dar Elfikr (Al Khalidiyah Branch)",
    type: "School",
    devices: 6,
    coordinates: [21.5874, 39.1099],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40032,
    name: "Dar Elfikr (Al Zahraa Branch)",
    type: "School",
    devices: 4,
    coordinates: [21.5740, 39.1302],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40033,
    name: "Al Faris International School",
    type: "School",
    devices: 3,
    coordinates: [21.6227, 39.1373],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40034,
    name: "Leaders International School",
    type: "School",
    devices: 4,
    coordinates: [21.6501, 39.1213],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40035,
    name: "Durat Al Andalus School",
    type: "School",
    devices: 5,
    coordinates: [21.5533, 39.1425],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40036,
    name: "Ekhaa Schools (Al Safa)",
    type: "School",
    devices: 3,
    coordinates: [21.5896, 39.1873],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40037,
    name: "Ekhaa Schools (North Obhur)",
    type: "School",
    devices: 2,
    coordinates: [21.7536, 39.1089],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40038,
    name: "Islamic Educational College",
    type: "School",
    devices: 3,
    coordinates: [21.5434, 39.1631],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40039,
    name: "Al Batarjee International School",
    type: "School",
    devices: 4,
    coordinates: [21.5730, 39.1258],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40040,
    name: "Waad Academy",
    type: "School",
    devices: 2,
    coordinates: [21.6012, 39.1115],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40041,
    name: "British International School of Jeddah",
    type: "School",
    devices: 5,
    coordinates: [21.5424, 39.1341],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40042,
    name: "American International School of Jeddah",
    type: "School",
    devices: 4,
    coordinates: [21.5637, 39.1156],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40043,
    name: "Jeddah Knowledge International School",
    type: "School",
    devices: 3,
    coordinates: [21.5989, 39.1287],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40044,
    name: "Al-Ahad Schools (Al Safa)",
    type: "School",
    devices: 2,
    coordinates: [21.5824, 39.1986],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40045,
    name: "Al-Mukhtar Model Schools",
    type: "School",
    devices: 3,
    coordinates: [21.6427, 39.1121],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40046,
    name: "Al Noor International School",
    type: "School",
    devices: 4,
    coordinates: [21.5678, 39.1895],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40047,
    name: "Coral International School",
    type: "School",
    devices: 3,
    coordinates: [21.7123, 39.1046],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40048,
    name: "Dar Al-Fikr Schools (Obhur)",
    type: "School",
    devices: 5,
    coordinates: [21.7532, 39.0943],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40049,
    name: "Creative Science Schools",
    type: "School",
    devices: 4,
    coordinates: [21.6342, 39.1478],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  // Additional Jeddah schools with IDs starting with 41001
  {
    id: 41001,
    name: "Anjal School (Rawdah)",
    type: "School",
    devices: 1,
    coordinates: [21.575588, 39.073870],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 487
    }
  },
  {
    id: 41002,
    name: "Rowad Alkhaleej School (Obhur)",
    type: "School",
    devices: 4,
    coordinates: [21.764550, 39.088565],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 461
    }
  },
  {
    id: 41003,
    name: "Al Thuraya Model Schools (Murjan)",
    type: "School",
    devices: 2,
    coordinates: [21.683960, 39.107430],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male, Female",
    ageRange: "3-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Kindergarten, Elementary, Intermediate",
      students: 295
    }
  },
  {
    id: 41004,
    name: "Advanced Generations Schools (Nahdah)",
    type: "School",
    devices: 11,
    coordinates: [21.628716, 39.123262],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 1500
    }
  },
  {
    id: 41005,
    name: "AMS Schools",
    type: "School",
    devices: 2,
    coordinates: [21.541068, 39.211776],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate, Secondary",
      students: 620
    }
  },
  {
    id: 41006,
    name: "Alokb School (Brakat)",
    type: "School",
    devices: 0,
    coordinates: [21.537047, 39.211227],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 155
    }
  },
  {
    id: 41008,
    name: "Alwah Schools (Makarim)",
    type: "School",
    devices: 0,
    coordinates: [21.551331, 39.177887],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 203
    }
  },
  {
    id: 41009,
    name: "MIS (Moktashef International School)",
    type: "School",
    devices: 10,
    coordinates: [21.609838, 39.071250],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 2300
    }
  },
  {
    id: 41010,
    name: "Al Mokhashef International School (AMIS)",
    type: "School",
    devices: 6,
    coordinates: [21.650326, 39.119534],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 1340
    }
  },
  {
    id: 41011,
    name: "JVS (Jeddah Knowledge School)",
    type: "School",
    devices: 4,
    coordinates: [21.598950, 39.128705],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 580
    }
  },
  {
    id: 41012,
    name: "Green Fields International Schools",
    type: "School",
    devices: 2,
    coordinates: [21.549672, 39.159543],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 327
    }
  },
  {
    id: 41014,
    name: "Al Motaqadimah Schools (FasFa)",
    type: "School",
    devices: 6,
    coordinates: [21.592984, 39.150414],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary, Intermediate, Secondary",
      students: 246
    }
  },
  {
    id: 41015,
    name: "Dar Al Hanan Schools",
    type: "School",
    devices: 4,
    coordinates: [21.603736, 39.157902],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 650
    }
  },
  {
    id: 41018,
    name: "Ibn Khaldoun International School",
    type: "School",
    devices: 2,
    coordinates: [21.620736, 39.138014],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 622
    }
  },
  {
    id: 41021,
    name: "Albawaba Schools",
    type: "School",
    devices: 1,
    coordinates: [21.590311, 39.162197],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 377
    }
  },
  {
    id: 41022,
    name: "AlNahda Int'l Schools",
    type: "School",
    devices: 5,
    coordinates: [21.595528, 39.180823],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 435
    }
  },
  {
    id: 41023,
    name: "Arayama",
    type: "School",
    devices: 3,
    coordinates: [21.790254, 39.178234],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "13-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Secondary",
      students: 458
    }
  },
  {
    id: 41024,
    name: "Dar Al-Ber",
    type: "School",
    devices: 2,
    coordinates: [21.620482, 39.168684],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 2053
    }
  },
  {
    id: 41025,
    name: "Jeddah International School",
    type: "School",
    devices: 1,
    coordinates: [21.580149, 39.153868],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 1087
    }
  },
  {
    id: 41027,
    name: "Waad Academy",
    type: "School",
    devices: 2,
    coordinates: [21.601278, 39.111482],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 1821
    }
  }
];
